import { useEffect, useRef } from "react";

export function useRefreshOnFocus(callback) {
    const callbackRef = useRef(callback);

    useEffect(() => {
        callbackRef.current = callback;
    });

    useEffect(() => {
        const trigger = () => callbackRef.current();

        const handleVisibilityChange = () => {
            if (document.visibilityState === 'visible') trigger();
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);
        window.addEventListener('focus', trigger);
        window.addEventListener('pageshow', trigger);

        return () => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
            window.removeEventListener('focus', trigger);
            window.removeEventListener('pageshow', trigger);
        };
    }, []);
}